import { render } from "./CurrencyColumn.vue?vue&type=template&id=05139d98"
import script from "./CurrencyColumn.vue?vue&type=script&lang=js"
export * from "./CurrencyColumn.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__